import styled from "styled-components";
import IconHeart from "../../icons/IconHeart";
import IconHeartSelected from "../../icons/IconHeartSelected";
import IconStar from "../../icons/IconStar";
import IconStarSelected from "../../icons/IconStarSelected";

type Props = {
  id?: number;
  type: "heart" | "star";
  favorite: boolean;
  onClick: (favorite: boolean) => void;
};

export const FavoriteIcon: React.FC<Props> = ({
  id,
  type,
  favorite,
  onClick,
}) => {
  return (
    <FavoriteIconContainer
      id={`store-favorite-icon-${id}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick(!favorite);
      }}
    >
      {type === "heart" ? (
        favorite ? (
          <IconHeartSelected />
        ) : (
          <IconHeart />
        )
      ) : favorite ? (
        <IconStarSelected />
      ) : (
        <IconStar />
      )}
    </FavoriteIconContainer>
  );
};

const FavoriteIconContainer = styled.div`
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  svg {
    width: 32px;
    height: 32px;
  }
`;
